import React from "react";
import "./ProjectDetail.scss";

import ProjectDetailHeader from "components/ProjectDetailHeader";
import Wrapper from "components/Wrapper";
import Thumbnail from "components/Thumbnail";
import DisplayGrid from "components/DisplayGrid";
import ProjectGallery from "components/ProjectGallery";

import { withFirebase } from "components/Firebase";
import { AuthUserContext } from "components/Session";

const TextContent = ({ descriptions, images }) => (
  <div
    className="TextContent"
    data-layout={images.length < 4 ? images.length : "multi"}
  >
    {descriptions.problem && (
      <Wrapper width={1065} center>
        <h5>The Problem</h5>
        <p>{descriptions.problem}</p>
      </Wrapper>
    )}
    {images.length < 3 && descriptions.solution && (
      <Wrapper width={1065} center>
        <h5>The Solution</h5>
        <p>{descriptions.solution}</p>
      </Wrapper>
    )}
    {images.length >= 3 && descriptions.solution && (
      <Wrapper>
        <br />
        <br />
        <br />
        <div className="flex-content sideText">
          <Thumbnail height={"auto"} width={"50%"} image={images[1].image} />
          <div className="text">
            <h5>The Solution</h5>
            <p>{descriptions.solution}</p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
      </Wrapper>
    )}
    {images.length === 2 && (
      <Wrapper width={1232} center>
        <br />
        <br />
        <br />
        <Thumbnail height={700} width={1232} image={images[1].image} />
        <br />
        <br />
        <br />
        <br />
        <br />
      </Wrapper>
    )}
    {descriptions.audience && (
      <Wrapper width={1065} center>
        <h5>The Audience</h5>
        <p>{descriptions.audience}</p>
      </Wrapper>
    )}
    {images.length === 3 && (
      <Wrapper width={1232} center>
        <br />
        <br />
        <br />
        <Thumbnail height={700} width={1232} image={images[2].image} />
        <br />
        <br />
        <br />
        <br />
        <br />
      </Wrapper>
    )}
    {images.length > 3 && (
      <Wrapper>
        <br />
        <br />
        <br />
        <div className="flex-content">
          <Thumbnail height={700} width={"50%"} image={images[2].image} />
          <Thumbnail height={700} width={"50%"} image={images[3].image} />
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
      </Wrapper>
    )}
    {descriptions.notes && (
      <Wrapper width={1065} center>
        <h5>Personal Notes</h5>
        <p>{descriptions.notes}</p>
      </Wrapper>
    )}
  </div>
);

class ProjectDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      project: {
        basicInformation: {
          description: ""
        },
        user: {
          firstName: "",
          lastName: "",
          userName: ""
        },
        descriptions: {
          audience: "",
          notes: "",
          problem: "",
          solution: ""
        },
        tags: {
          skills: [],
          other: []
        },
        images: [
          {
            image: ""
          }
        ]
      },
      otherProjects: []
    };
  }
  componentDidMount() {
    const projectId = this.props.match.params.id;
    this.getProjectInfo(projectId);
  }

  getProjectInfo = projectId => {
    this.setState({ loaded: false });
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
    this.props.firebase
      .project(projectId)
      .get()
      .then(doc => {
        this.setState({ project: doc.data() });

        const otherProjects = [];
        this.props.firebase
          .projectsByUser(this.state.project.user.id)
          .get()
          .then(({ docs }) => {
            docs.map((doc, i) => {
              otherProjects.push(doc.data());
              const filteredProjects = otherProjects.filter(
                project => project.id !== projectId
              );
              this.setState({ otherProjects: filteredProjects, loaded: true });
              return true;
            });
          })
          .catch(error => console.error(error));
      })
      .catch(error => console.error(error));
  };

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.getProjectInfo(this.props.match.params.id);
    }
  }
  render() {
    const { descriptions, images, user, basicInformation } = this.state.project;
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          <div className="ProjectDetail" data-loaded={this.state.loaded}>
            {images[0] && (
              <div
                className="HeaderImage"
                style={{
                  backgroundImage: `url(${images[0].image})`
                }}
              />
            )}

            <Wrapper width={1065} center>
              <ProjectDetailHeader
                user={user}
                project={this.state.project}
                isProjectOwner={
                  authUser && authUser.uid === user.id ? true : false
                }
              />
            </Wrapper>
            {/* <RationaleColumns images={images} descriptions={descriptions} /> */}
            {!descriptions.problem &&
            !descriptions.solution &&
            !descriptions.audience &&
            !descriptions.notes ? (
              <Wrapper width={1232} center>
                <p className="large">{basicInformation.description}</p>
                <div className="ImagesOnly">
                  {images &&
                    images.map((image, i) => {
                      if (i === 0) {
                        return false;
                      }
                      return image.image ? (
                        <Thumbnail image={image.image} height={800} />
                      ) : (
                        false
                      );
                    })}
                </div>
              </Wrapper>
            ) : (
              <>
                <TextContent images={images} descriptions={descriptions} />
                {images.length > 3 ? (
                  <div className="Gallery">
                    <ProjectGallery images={images} />
                  </div>
                ) : null}
              </>
            )}

            <Wrapper width={1232} center>
              {this.state.otherProjects.length > 0 ? (
                <DisplayGrid
                  projects={this.state.otherProjects}
                  // actions={actions}
                />
              ) : null}
              <br />
              <br />
              <br />
              <br />
            </Wrapper>
          </div>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

export default withFirebase(ProjectDetail);
